package org.dronda.app.web

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import org.dronda.app.web.client.AuthClient
import org.dronda.app.web.client.EventClient
import org.dronda.app.web.client.GroupClient
import org.dronda.app.web.client.LocationSharingClient
import org.dronda.app.web.client.WishlistClient
import org.dronda.app.web.client.buildClient
import org.dronda.app.web.repository.AuthRepository
import org.dronda.app.web.repository.EventRepository
import org.dronda.app.web.repository.GroupRepository
import org.dronda.app.web.repository.LocationSharingRepository
import org.dronda.app.web.repository.UserRepository
import org.dronda.app.web.repository.WishlistRepository
import org.dronda.app.web.service.AuthService
import org.dronda.app.web.service.OwntracksConfigurationService
import org.dronda.app.web.ui.MainScreenViewModel
import org.dronda.app.web.ui.eventadmin.EventAdminViewModel
import org.dronda.app.web.ui.eventcreate.CreateEventViewModel
import org.dronda.app.web.ui.eventdetail.EventDetailViewModel
import org.dronda.app.web.ui.events.EventsViewModel
import org.dronda.app.web.ui.locationconfig.LocationConfigViewModel
import org.dronda.app.web.ui.login.LoginViewModel
import org.dronda.app.web.ui.wishlist.WishlistViewModel

class MainModule {
    private val authClient = AuthClient()
    val authRepository = AuthRepository(authClient)

    private val authService = AuthService(authClient, authRepository)
    private val userRepository = UserRepository(authRepository)

    private val client = buildClient(authRepository)
    private val locationSharingClient = LocationSharingClient(client)
    private val eventClient = EventClient(client)
    private val groupClient = GroupClient(client)
    private val wishlistClient = WishlistClient(client)

    val locationSharingRepository = LocationSharingRepository(locationSharingClient)
    val eventRepository = EventRepository(eventClient)
    val groupRepository = GroupRepository(groupClient)
    val wishlistRepository = WishlistRepository(wishlistClient)

    val owntracksConfigurationService = OwntracksConfigurationService()

    val mainScreenViewModelFactory: ViewModelFactory<MainScreenViewModel> = {
        MainScreenViewModel(userRepository)
    }
    val loginViewModelFactory: ViewModelFactory<LoginViewModel> = {
        LoginViewModel(authService)
    }
    val locationConfigViewModelFactory: ViewModelFactory<LocationConfigViewModel> = {
        LocationConfigViewModel(
            userRepository = userRepository,
            owntracksConfigurationService = owntracksConfigurationService,
            locationSharingRepository = locationSharingRepository
        )
    }
    val eventsViewModelFactory: ViewModelFactory<EventsViewModel> = {
        EventsViewModel(eventRepository)
    }
    val createEventViewModelFactory: (String) -> CreateEventViewModel = { creatorEmail ->
        CreateEventViewModel(creatorEmail, eventRepository)
    }
    val eventDetailViewModelFactory: (String) -> EventDetailViewModel = { eventId ->
        EventDetailViewModel(eventId, eventRepository)
    }
    val eventAdminViewModelFactory: (String) -> EventAdminViewModel = { eventId ->
        EventAdminViewModel(eventId, eventRepository)
    }
    val wishlistViewModelFactory: (String, String) -> WishlistViewModel = { wishlistId, currentUserId ->
        WishlistViewModel(wishlistId, currentUserId, wishlistRepository)
    }
}

typealias ViewModelFactory<VM> = () -> VM

@Composable
fun <VM> rememberViewModel(viewModelFactory: ViewModelFactory<VM>): VM {
    return remember { viewModelFactory() }
}
